<template>
  <PreChatForm :prechatInputs="inputs" :disabled="activeDataCollectionStatus(id)" :userDetails="userDetails"  :modelData="getFormData" @submit="submitForm" isMidChatForm />
</template>

<script>
import PreChatForm from './PreChatForm.vue'
import { mapActions, mapState } from 'pinia'
import { useWidgetStore } from '@/store'

export default {
  props: {
    inputs: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    midChatForm: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    userDetails: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    PreChatForm
  },
  computed: {
    ...mapState(useWidgetStore, [
      'activeDataCollectionStatus',
      'getDataCollectionFormModel'
    ]),
    getFormData () {
      return this.getDataCollectionFormModel(this.id)?.form || {}
    }
  },
  mounted () {
    console.log('MidChatForm mounted', this.userDetails)
  },
  methods: {
    ...mapActions(useWidgetStore, [
      'setDataCollectionStatus',
      'setDataCollectionForm'
    ]),
    getCookie (name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      if (match) return match[2]
    },
    submitForm (data) {
      this.$emit('submitForm', {
        form: data.form,
        id: this.id
      })
      this.setDataCollectionStatus(this.id)
      this.setDataCollectionForm({ form: data.form, id: this.id })
    }
  }
}
</script>
